import * as yup from 'yup';

export const city = yup.string().required('Påkrævet');
